import { Action } from '@ngrx/store';
import { PrescriptorData } from '../models/store.model';


export const SETPRESCRIPTORDATA = '[PrescriptorData] Set Prescriptor Data';
export const UNSETPRESCRIPTORDATA = '[PrescriptorData] Unset Prescriptor Data';

export class SetPrescriptorData implements Action {
    readonly type = SETPRESCRIPTORDATA;
    constructor(public prescriptor: PrescriptorData) { }
}

export class UnsetPrescriptorData implements Action {
    readonly type = UNSETPRESCRIPTORDATA;
}

export type PrescriptorDataActions =
    | SetPrescriptorData
    | UnsetPrescriptorData;

